const gioiTinhOptions = [
  {value: null, label: ""},
  {value: 0, label: "Nam"},
  {value: 1, label: "Nữ"},
];

const loaiKCBOptions = [
  {value: 0, label: "Thông thường"},
  {value: 1, label: "Cấp cứu"},
  {value: 2, label: "Tái khám thông thường"},
  {value: 3, label: "Tái khám sau phẫu thuật"},
  {value: 4, label: "Hẹn phẫu thuật"},
  {value: 5, label: "Khám đo kính"},
  {value: 6, label: "Định kỳ"},
  {value: 7, label: "Khác"},
];

const trangThaiPKOptions = [
  {value: 0, label: "Phiếu khám mới"},
  {value: 1, label: "Chờ thực hiện"},
  {value: 2, label: "Đang thực hiện"},
  {value: 3, label: "Hoàn thành"},
  {value: 4, label: "Chờ kết quả xét nghiệm"},
  {value: 5, label: "Đã có kết quả xét nghiệm"},
  {value: 6, label: "Hủy thực hiện"},
  {value: 7, label: "Đã xóa"},
  {value: 8, label: "Chờ tời ngày thực hiện"}
];

const trangThaiThanhToanOptions = [
  {value: 0, label: "Chưa thanh toán"},
  {value: 1, label: "Đã thanh toán"},
  {value: 2, label: "Hủy thanh toán"},
];

const khuKCBOptions = [
  {value: null, label: ""},
  {value: 0, label: "Khu khám thường"},
  {value: 1, label: "Khu khám VIP"},
];

const trangThaiBHOptions = [
  {value: null, label: "Chưa có thông tin"},
  {value: 1, label: "Còn hạn"},
  {value: 2, label: "Hết hạn"},
];

const trangThaiTheBNOptions = [
  {value: 0, label: "Còn hạn"},
  {value: 1, label: "Hết hạn"},
  {value: 2, label: "Huỷ"},
];

const doiTuongOptions = [
  {value: null, label: ""},
  {value: 0, label: "Viện phí"},
  {value: 1, label: "Cấp cứu"},
  {value: 2, label: "Bảo hiểm"},
  {value: 3, label: "Khám đoàn"},
];

const doiTuongKCB = [
  {value: null, label: "Viện phí"},
  {value: 0, label: "Có bảo hiểm"},
  {value: 1, label: "Viện phí"},
];

const nguonBNOptions = [
  {value: null, label: ""},
  {value: 0, label: "Organic"},
  {value: 1, label: "Sale"},
  {value: 2, label: "CTV"},
  {value: 3, label: "Return"},
  {value: 4, label: "CSKH"},
  {value: 5, label: "Camp tại địa phương"},
  {value: 6, label: "Đoàn khám tại"},
];

const quanHeThanNhanOptions = [
  {value: null, label: ""},
  {value: 0, label: "Con"},
  {value: 1, label: "Bố"},
  {value: 2, label: "Mẹ"},
  {value: 3, label: "Ông"},
  {value: 4, label: "Bà"},
  {value: 5, label: "Vợ"},
];

const dichVuKhamOptions = [
  {value: 0, label: "Khám mắt"},
  {value: 1, label: "Khám mắt VIP"},
  {value: 2, label: "Khám mắt VIP (không đặt hẹn)"},
  {value: 3, label: "Khám lại trong 7 ngày (áp dụng đối với bệnh nhân khám)"},
  {value: 4, label: "Khám khúc xạ đơn kính"},
  {
    value: 5,
    label: "Khám khúc xạ chuyên sâu ((nhỏ Cyclogin, soi bóng đồng tử)",
  },
];

export {
  gioiTinhOptions,
  loaiKCBOptions,
  trangThaiPKOptions,
  khuKCBOptions,
  trangThaiBHOptions,
  quanHeThanNhanOptions,
  trangThaiTheBNOptions,
  doiTuongOptions,
  nguonBNOptions,
  doiTuongKCB
};
